import { useMutation, useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router";
import { Drawer } from "../shared/Drawer";
import { DynamicGrid } from "../dynamicGrid";
import { usePrivacyNavigate } from "../shared/usePrivacyNavigate";
import { TenantIcon2 } from "../shared/icons";
import {
  enterpriseCustomerOrganisationsQueryOptions,
  updateProductAdminsMutationOptions,
} from "../api/enterpriseCustomer";
import { OrganisationActionMenu } from "./OrganisationActionMenu";
import { ProductAdminsField } from "./ProductAdminsField";

export const OrganisationDrawer = () => {
  const { navigate, paths } = usePrivacyNavigate();
  const selectedRowId = DynamicGrid.useSelectedRowId();
  const organisationsQuery = useQuery(enterpriseCustomerOrganisationsQueryOptions());
  const updateProductAdminsMutation = useMutation(updateProductAdminsMutationOptions());

  return (
    <DynamicGrid.Drawer>
      {(() => {
        if (!organisationsQuery.data) return <Drawer.Loading />;

        const organisation = organisationsQuery.data.find(({ id }) => id === selectedRowId);

        if (!organisation) return <Navigate to={paths.enterpriseCustomerOrganisations()} replace />;

        return (
          <>
            <Drawer.Header
              title={organisation.organizationName}
              status={updateProductAdminsMutation.status}
              onClose={() => navigate(paths.enterpriseCustomerOrganisations())}
              renderIcon={props => <TenantIcon2 {...props} />}
              topRightSlot={
                <OrganisationActionMenu
                  organisation={organisation}
                  onDeleted={() => navigate(paths.enterpriseCustomerOrganisations())}
                  ariaLabelKey="GridDrawer.Menu.ButtonLabel"
                />
              }
            />
            <Drawer.Content>
              <ProductAdminsField
                organisation={organisation}
                updateProductAdminsMutation={updateProductAdminsMutation}
              />
            </Drawer.Content>
          </>
        );
      })()}
    </DynamicGrid.Drawer>
  );
};
